var $76fcf5a65228b865$exports = {};
$76fcf5a65228b865$exports = {
    "moreActions": `More actions`,
    "unavailable": `Unavailable, expand for details`,
    "backButton": (args)=>`Return to ${args.prevMenuButton}`
};


export {$76fcf5a65228b865$exports as default};
//# sourceMappingURL=en-US.mjs.map
